import { render, staticRenderFns } from "./diseases.vue?vue&type=template&id=1f3ad49f&scoped=true&"
import script from "./diseases.vue?vue&type=script&lang=js&"
export * from "./diseases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ad49f",
  null
  
)

export default component.exports